<template>
  <qx-card title="列表">
    <span slot="titleLeft">
      【申请总金额：<span class="primary">{{tableData.originData.total}}</span>】
    </span>
    <LogRightDialog
      ref="logRightDialog"
      busiCode="imp100041"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleFeePaymentParBO.ajax?cmd=doQueryDetailList'
          :params="fullSearchData"
          bizName="费用明细数据导出"
          bizCode="WF00000958"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'plateNumber'"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'orderId'" @click="toOrderDetail(scope.row)">
                <span class="primary">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-if="scope.column.property === 'busiCode'" @click="toCarCostDetail(scope.row)">
                <span class="primary">{{scope.row[scope.column.property]}}</span>
              </section>
              <section
                v-if="
                  scope.column.property !== 'orderId' &&
                  scope.column.property !== 'busiCode'
                "
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import {
  costDetailList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        originData: {},
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'costTypeName',
            label: '费用类型',
          },
          {
            prop: 'payAmt',
            label: '申请金额(元)',
          },
          {
            prop: 'applyTime',
            label: '申请时间',
          },
          {
            prop: 'feeAscriptionDate',
            label: '费用归属日期',
          },
          {
            prop: 'applyUserName',
            label: '申请人',
          },
          {
            prop: 'orderId',
            label: '订单号码',
          },
          {
            prop: 'orgName',
            label: '费用归属',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
          {
            prop: 'busiCode',
            label: '申请单号',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: costDetailList,
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toCarCostDetail (item) {
      console.log('toCarCostDetail');
      // this.jump({
      //   label: type ? '审核客户' : '客户详情',
      //   url: `/manage/cost/borrow/driver/detail?id=${item.customerId}&type=${type}`,
      //   full: true,
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
